import * as z from 'zod';

import { VendedorSchema } from './VendedorSchema';
import { empresaSchema } from './EmpresaSchema';
import { ProdutoSchema } from './ProdutoSchema';

export const schema = z.object({
  vendedor: VendedorSchema,
  empresa: empresaSchema,

  planos: z.array(ProdutoSchema).optional(),
});

export type Schema = z.infer<typeof schema>;
